import { useList } from '@pankod/refine-core'
import { Box, Card, Typography } from '@pankod/refine-mui'

import { AgentCard } from 'components'

const Agents = () => {
  const { data, isLoading, isError } = useList({ resource: 'users' })

  const allAgents = data?.data ?? []

  if (isLoading) return <div>loading...</div>
  if (isError) return <div>error...</div>

  return (
    <Box>
      <Typography
        fontSize={25}
        fontWeight={700}
        // color="#11142d"
      >
        Agents List
      </Typography>

      {/* <Box
        mt="20px"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          backgroundColor: '#fcfcfc',
        }}
      > */}
      <Card
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',


          borderRadius: '15px',
          
          // padding: '20px',
          '&:hover': {
            boxShadow: '0 22px 45px 2px rgba(176, 176, 176, 0.1)',
          },
          // cursor: 'pointer',
          marginTop: '20px',
        }}
        elevation={0}
      >
        {allAgents.map((agent) => (
          <AgentCard
            key={agent._id}
            id={agent._id}
            name={agent.name}
            email={agent.email}
            avatar={agent.avatar}
            noOfProperties={agent.allProperties.length}
          />
        ))}
      </Card>
    </Box>
  )
}

export default Agents
